/* Custom Product Showcase — supports multiple instances + Shopify theme editor. */
(function () {
  'use strict';

  function initShowcase(section) {
    if (!section || section.dataset.cpsReady === 'true') return;
    section.dataset.cpsReady = 'true';

    const triggers = Array.from(section.querySelectorAll('[data-cps-trigger]'));
    const panels = Array.from(section.querySelectorAll('[data-cps-panel]'));

    function selectProduct(id) {
      if (!panels.some(panel => panel.dataset.cpsPanel === id)) return;
      triggers.forEach(trigger => {
        const active = trigger.dataset.cpsTrigger === id;
        trigger.classList.toggle('is-active', active);
        trigger.setAttribute('aria-pressed', String(active));
      });
      panels.forEach(panel => { panel.hidden = panel.dataset.cpsPanel !== id; });
    }

    triggers.forEach(trigger => {
      trigger.addEventListener('click', () => selectProduct(trigger.dataset.cpsTrigger));
    });

    section.querySelectorAll('[data-cps-panel]').forEach(panel => {
      const faqs = Array.from(panel.querySelectorAll('[data-cps-faq]'));
      faqs.forEach(faq => {
        const button = faq.querySelector('[data-cps-faq-button]');
        if (!button) return;
        button.addEventListener('click', () => {
          const shouldOpen = button.getAttribute('aria-expanded') !== 'true';
          faqs.forEach(item => {
            const otherButton = item.querySelector('[data-cps-faq-button]');
            const answer = item.querySelector('[data-cps-faq-answer]');
            const isOpen = item === faq && shouldOpen;
            if (otherButton) otherButton.setAttribute('aria-expanded', String(isOpen));
            if (answer) answer.hidden = !isOpen;
          });
        });
      });
    });

    const initialActive = triggers.find(trigger => trigger.classList.contains('is-active'));
    if (initialActive) selectProduct(initialActive.dataset.cpsTrigger);
    section.addEventListener('cps:select', event => {
      if (event.detail && event.detail.id) selectProduct(event.detail.id);
    });
  }

  function initializeAll(scope) {
    if (scope.matches && scope.matches('[data-custom-product-showcase]')) initShowcase(scope);
    scope.querySelectorAll('[data-custom-product-showcase]').forEach(initShowcase);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(document));
  } else {
    initializeAll(document);
  }

  document.addEventListener('shopify:section:load', event => initializeAll(event.target));
  document.addEventListener('shopify:block:select', event => {
    const block = event.target.closest('[data-cps-trigger]');
    if (!block) return;
    const section = block.closest('[data-custom-product-showcase]');
    if (section) section.dispatchEvent(new CustomEvent('cps:select', { detail: { id: block.dataset.cpsTrigger } }));
  });
})();
